import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { GradientLogo } from "./Nav";
import { AppStoreButton } from "./AppStoreButton";

const scrollTo = (id) => {
  const el = document.querySelector(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  return (
    <footer className="relative pt-24 pb-10 border-t border-black/5" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-3xl border border-[color:var(--line)] p-10 md:p-16 overflow-hidden bg-white shadow-xl"
        >
          <div
            className="absolute inset-0 opacity-90 pointer-events-none"
            style={{
              background:
                "radial-gradient(60% 60% at 20% 20%, var(--accent-soft), transparent 60%), radial-gradient(60% 60% at 80% 80%, var(--blue-soft), transparent 60%), radial-gradient(60% 60% at 60% 40%, var(--purple-soft), transparent 60%)",
            }}
          />
          <div className="relative grid md:grid-cols-12 gap-10 items-end">
            <div className="md:col-span-8">
              <div className="overline mb-4">Ready?</div>
              <h3
                className="font-display font-medium tracking-tighter text-[color:var(--ink)] leading-[0.9]"
                style={{ fontSize: "clamp(52px, 8.5vw, 148px)" }}
              >
                Stop
                <br />
                <span className="gradient-text" style={{ fontFamily: "var(--font-serif)", fontStyle: "italic" }}>
                  forgetting.
                </span>
              </h3>
            </div>
            <div className="md:col-span-4 flex flex-col gap-3">
              <div className="flex flex-wrap gap-3">
                <AppStoreButton variant="apple" testid="footer-app-store" />
                <AppStoreButton variant="google" testid="footer-play-store" />
              </div>
              <button
                onClick={() => scrollTo("#waitlist")}
                data-testid="footer-waitlist"
                className="mt-2 group inline-flex items-center gap-3 rounded-full h-12 pl-5 pr-3 border border-[color:var(--line-strong)] hover:border-[color:var(--ink)] text-[color:var(--ink)] font-medium transition-colors self-start bg-white"
              >
                <span>Join waitlist</span>
                <span className="w-8 h-8 rounded-full bg-[color:var(--blue)] flex items-center justify-center">
                  <ArrowUpRight className="w-3.5 h-3.5 text-white" />
                </span>
              </button>
            </div>
          </div>
        </motion.div>

        <div className="mt-16">
          <div className="md:max-w-md">
            <GradientLogo />
            <p className="mt-6 text-[color:var(--ink-soft)] text-sm max-w-xs leading-relaxed">
              A contact organiser for everyone with a messy phonebook. Coming soon to iOS and Android.
            </p>
            <div className="mt-8 chip">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
              <span>App launch — Q1 2026</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col md:flex-row items-center justify-between gap-4 text-[color:var(--ink-mute)] text-xs">
          <div>© {new Date().getFullYear()} BizBinder. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>Made for people, not pipelines.</span>
            <a href="#" className="link-underline">Twitter</a>
            <a href="#" className="link-underline">LinkedIn</a>
            <a href="#" className="link-underline">Instagram</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
